/* eslint-disable prettier/prettier */
import React, { memo } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { noop } from '@/pages/home/utils/utils';
import { IImagesUploaderBtnProps } from '@/pages/home/components/ImagesUploader/types';
import SvgIcon from '@/pages/home/components/SvgIcon';

const ImagesUploaderBtn: React.FC<IImagesUploaderBtnProps> = (props) => {
  const {
    multiple = true,
    accept = 'images/*',
    disabled = false,
    onChange = noop,
    isNeedUnloadModalDesc = true,
    ...rest
  } = props;

  const { formatMessage } = useIntl();

  return (
    <div className="unloadModal-upbtn" {...rest}>
      <div
        className={classnames('unloadModal-btn tea-btn tea-btn--weak',
          {
            disabled,
          },
          {
            'dbi-unloadModal-upbtn-feedback-truedata': !isNeedUnloadModalDesc,
          },
        )}
        style={{ position: 'relative' }}
      >
        {!isNeedUnloadModalDesc && <SvgIcon type="upload" className="dbi-feedback-btn-icon" />}
        {formatMessage({
          id: isNeedUnloadModalDesc ? 'dbh_feedback_upload_img_control_text' : 'dbi_feedback_upload_image',
          defaultMessage: 'Select image',
        })}
        <input
          type="file"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0,
          }}
          disabled={disabled}
          multiple={multiple}
          accept={accept}
          onChange={onChange}
        />
      </div>
      {isNeedUnloadModalDesc && <div className="unloadModal-desc">
        {formatMessage({
          id: 'dbh_feedback_upload_img_control_tips',
          defaultMessage: 'Support batch upload',
        })}
      </div>}
    </div>
  );
};

export default memo(ImagesUploaderBtn);
